import { IInstaAllPostData } from "@smartrr/shared/entities/Instagram";

import { CustomerSubReducer } from "@customer-app/state/typedCustomerRedux";

export interface IInstagramPostsReducerState extends IInstaAllPostData {
  isLoading: boolean;
  firstLoad: boolean;
}

const initialState: IInstagramPostsReducerState = {
  isLoading: true,
  firstLoad: false,
  data: [],
};

export const isAccessTokenExpired = (expires_in: number, createdDate: Date) => {
  const d = Math.floor(expires_in / (3600 * 24)) - 2; // 2 days before token expiration
  const c = new Date(createdDate);
  c.setDate(c.getDate() + d);
  const now = new Date();
  return now.getTime() > c.getTime();
};

export const instagramPostsReducer: CustomerSubReducer<IInstagramPostsReducerState> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case "LOADING_INSTAGRAM_USER_POSTS": {
      return {
        ...state,
        isLoading: true,
        firstLoad: true,
      };
    }

    case "ERROR_LOADING_INSTAGRAM_USER_POSTS": {
      return {
        ...state,
        isLoading: false,
      };
    }

    case "INSTAGRAM_USER_POSTS_SUCCESS": {
      return {
        ...state,
        ...action.payload.data,
        isLoading: false,
      };
    }

    default: {
      return state;
    }
  }
};
